import React from "react";
import { StarIcon } from "lucide-react";
const stats = [{
  value: "4.9/5",
  label: "Valoración media",
  star: true
}, {
  value: "+300",
  label: "Recursos profesionales"
}, {
  value: "+2.000",
  label: "Técnicos"
}, {
  value: "99%",
  label: "Lo recomendaría"
}];
export function SocialProof() {
  return <section className="w-full bg-neutral-900 py-10" data-id="element-166" data-mp="3btvdu4rel0az">
      <div className="mx-auto max-w-lg px-4" data-id="element-167" data-mp="3bwhseocpog2p">
        <p className="text-center text-sm leading-relaxed text-white/70" data-id="element-168" data-mp="3fwfiwgyl2ub">
          Más de{" "}
          <span className="font-bold text-white" data-id="element-169" data-mp="8cwlz8hq07ly">2.000 técnicos</span> ya
          utilizan Sistema Técnico PRO 360 para organizar su negocio y ahorrar
          horas de trabajo administrativo.
        </p>
        <div className="mt-6 grid grid-cols-2 gap-3" data-id="element-170" data-mp="3ushfbkqu0tff">
          {stats.map(s => <div key={s.label} className="rounded-xl border border-white/10 bg-neutral-950 px-3 py-4 text-center" data-id="element-171" data-mp="mdh3m1bwfxdv">
              <div className="flex items-center justify-center gap-1 font-display text-2xl font-extrabold text-amber-400" data-id="element-172" data-mp="r6ac90ahnpv8">
                {s.star && <StarIcon className="h-5 w-5 fill-amber-400 text-amber-400" data-id="element-173" data-mp="1pc2y1nrvjy2d" />}
                {s.value}
              </div>
              <div className="mt-1 text-[11px] font-medium uppercase tracking-wide text-white/60" data-id="element-174" data-mp="241h9r2ixarkx">
                {s.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}